import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);
const KEY = (slug) => `tk_cart_${slug}`;

export const CartProvider = ({ slug, children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!slug) return;
    try {
      const raw = localStorage.getItem(KEY(slug));
      setItems(raw ? JSON.parse(raw) : []);
    } catch { setItems([]); }
  }, [slug]);

  useEffect(() => {
    if (slug) localStorage.setItem(KEY(slug), JSON.stringify(items));
  }, [items, slug]);

  const add = useCallback((sku, qty = 1, meta = {}) => {
    setItems((prev) => {
      const existing = prev.find((p) => p.sku_variante === sku);
      if (existing) return prev.map((p) => p.sku_variante === sku ? { ...p, qta: p.qta + qty } : p);
      return [...prev, { sku_variante: sku, qta: qty, ...meta }];
    });
    setOpen(true);
  }, []);

  const update = useCallback((sku, qty) => {
    setItems((prev) => qty <= 0 ? prev.filter((p) => p.sku_variante !== sku) : prev.map((p) => p.sku_variante === sku ? { ...p, qta: qty } : p));
  }, []);

  const remove = useCallback((sku) => {
    setItems((prev) => prev.filter((p) => p.sku_variante !== sku));
  }, []);

  const clear = useCallback(() => setItems([]), []);
  const count = items.reduce((s, i) => s + i.qta, 0);

  return (
    <CartContext.Provider value={{ items, count, open, setOpen, add, update, remove, clear, slug }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart deve essere usato dentro <CartProvider>");
  return ctx;
};
